import React, { useEffect, useState, useRef } from "react";
import { motion } from "framer-motion";
import i18next from "i18next";
import translateIcon from "../assets/images/traslate-icon.png";
import { useAppState } from "context/AppContext ";

const languages = [
  { code: "en", label: "English" },
  { code: "fr", label: "French" },
  { code: "hi", label: "Hindi" },
];

const LanguageSelector = () => {
  const dropdownRef = useRef(null);
  const { lang, setLang } = useAppState();
  const [languageDropdownOpen, setLanguageDropdownOpen] = useState(false);

  const toggleLanguageDropdown = () => {
    setLanguageDropdownOpen(!languageDropdownOpen);
  };

  const handleLanguageChange = (languageCode) => {
    setLang(languageCode);
    i18next.changeLanguage(languageCode);
    localStorage.setItem("selectedLanguage", languageCode);
    setLanguageDropdownOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setLanguageDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setLang(localStorage.getItem("selectedLanguage") || "en");
    i18next.changeLanguage(localStorage.getItem("selectedLanguage") || "en");
  }, []);

  return (
    <div className="relative cursor-pointer" ref={dropdownRef}>
      <div
        className="w-[40px] h-[40px] flex items-center justify-center"
        onClick={toggleLanguageDropdown}
      >
        <img
          src={translateIcon}
          alt="translate Icon"
          className="w-full object-contain"
        />
      </div>
      {languageDropdownOpen && (
        <motion.ul
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          className="absolute right-0 mt-2 py-2 w-40 bg-white shadow-md rounded-lg z-50 gap-0"
        >
          {languages.map((lan) => (
            <li
              key={lan.code}
              className={`py-1 cursor-pointer hover:bg-gray-200 ${
                lang === lan.code ? "text-secondary-dark font-semibold" : ""
              } text-center text-[14px]`}
              onClick={() => handleLanguageChange(lan.code)}
            >
              {lan.label}
            </li>
          ))}
        </motion.ul>
      )}
    </div>
  );
};

export default LanguageSelector;
